import axios from '@/util/request'

const baseURL = process.env.VUE_APP_REPORT_URL

export default {
  report: data => axios({ baseURL, url: '/api/report/open/buried', method: 'post', data }), // 数据埋点上报

  tracking: data => axios({ baseURL, url: '/api/report/open/tracking', method: 'post', data }), // 数据埋点上报

  getSystemIP: params => axios({ url: '/api/system/open/ip', method: 'get', params }) // 获取ip与地址信息
}
